var map = {
	"./ai/spanBorder.svg": 450,
	"./computernaya-gramotnost/spanBorder.svg": 451,
	"./ege-informatika/spanBorder.svg": 420,
	"./frontend/spanBorder.svg": 452,
	"./game-design/spanBorder.svg": 453,
	"./graphic-design-pro/spanBorder.svg": 454,
	"./graphic-design/spanBorder.svg": 455,
	"./intensive/spanBorder.svg": 456,
	"./osnovy-programmirovaniya/spanBorder.svg": 457,
	"./predprinimatelstvo/spanBorder.svg": 458,
	"./python/spanBorder.svg": 459,
	"./scratch/spanBorder.svg": 460,
	"./unity/spanBorder.svg": 461,
	"./videoblogging/spanBorder.svg": 462,
	"./web-razrabotka/spanBorder.svg": 463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 823;